import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .rc-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .rc-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .rc-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .rc-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(217,119,6,0.08), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .rc-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 700px; height: 700px; border-radius: 50%; background: radial-gradient(circle, rgba(30,58,138,0.07), rgba(217,119,6,0.04)); filter: blur(90px); pointer-events: none; }
  .rc-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .rc-hero-inner { grid-template-columns: 1fr; } .rc-hero-card { display: none; } }

  .rc-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #fffbeb; border: 1px solid #fde68a; font-size: 13px; font-weight: 500; color: #92400e; margin-bottom: 28px; }
  .rc-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #f59e0b; display: inline-block; animation: rc-pulse 2s ease-in-out infinite; }
  @keyframes rc-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,158,11,0.5); } 50% { box-shadow: 0 0 0 6px rgba(245,158,11,0); } }

  .rc-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .rc-gradient-text { background: linear-gradient(135deg, #d97706 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .rc-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .rc-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .rc-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .rc-btn-primary:hover { background: #d97706; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(217,119,6,0.3); }
  .rc-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: #d97706; background: none; border: none; cursor: pointer; padding: 0; margin-bottom: 24px; transition: color 0.2s; }
  .rc-back-btn:hover { color: #b45309; }
  .rc-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .rc-btn-secondary:hover { border-color: #f59e0b; color: #92400e; background: #fffbeb; }
  .rc-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .rc-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .rc-trust-check { width: 20px; height: 20px; background: #fef3c7; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #d97706; flex-shrink: 0; }

  /* Hero Card */
  .rc-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .rc-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .rc-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .rc-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .rc-card-status-badge { background: #fef3c7; color: #92400e; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .rc-compliance-item { display: flex; align-items: center; justify-content: space-between; padding: 11px 14px; border-radius: 10px; background: #f8fafc; border: 1px solid #f1f5f9; margin-bottom: 8px; }
  .rc-comp-left { display: flex; align-items: center; gap: 10px; }
  .rc-comp-icon { font-size: 16px; }
  .rc-comp-label { font-size: 13px; font-weight: 600; color: #334155; }
  .rc-comp-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .rc-comp-badge { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; }
  .rc-badge-pass { background: #dcfce7; color: #166534; }
  .rc-badge-action { background: #fef9c3; color: #854d0e; }
  .rc-badge-risk { background: #fee2e2; color: #991b1b; }
  .rc-score-bar { margin-top: 14px; padding: 16px 18px; background: linear-gradient(135deg, #92400e, #d97706); border-radius: 12px; }
  .rc-score-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
  .rc-score-label { font-size: 11px; color: rgba(255,255,255,0.75); }
  .rc-score-value { font-size: 22px; font-weight: 800; color: #fff; }
  .rc-score-bar-track { background: rgba(255,255,255,0.2); border-radius: 999px; height: 6px; }
  .rc-score-bar-fill { background: #fbbf24; border-radius: 999px; height: 6px; width: 78%; }

  /* ── Stats ── */
  .rc-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .rc-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .rc-stats-grid { grid-template-columns: 1fr 1fr; } }
  .rc-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .rc-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .rc-stat-item:nth-child(2n) { border-right: none; } .rc-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .rc-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #d97706; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .rc-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared ── */
  .rc-section { padding: 96px 24px; }
  .rc-container { max-width: 1200px; margin: 0 auto; }
  .rc-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .rc-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .rc-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .rc-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #d97706; margin-bottom: 12px; }

  /* ── Compliance Areas ── */
  .rc-areas-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .rc-areas-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .rc-areas-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .rc-areas-grid { grid-template-columns: 1fr; } }
  .rc-area-card { background: #fff; padding: 32px 28px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; }
  .rc-area-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); }
  .rc-area-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; background: linear-gradient(90deg, #d97706, #f59e0b); }
  .rc-area-card:hover::before { opacity: 1; }
  .rc-area-icon { font-size: 28px; margin-bottom: 16px; }
  .rc-area-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .rc-area-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; margin-bottom: 16px; }
  .rc-area-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .rc-area-tag { background: #fffbeb; border: 1px solid #fde68a; color: #92400e; font-size: 10.5px; font-weight: 600; padding: 3px 10px; border-radius: 999px; }

  /* ── Risk Section ── */
  .rc-risk-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: start; }
  @media (max-width: 900px) { .rc-risk-grid { grid-template-columns: 1fr; gap: 40px; } }
  .rc-risk-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.6rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .rc-risk-left p { font-size: 1.02rem; color: #64748b; line-height: 1.78; margin-bottom: 36px; }
  .rc-risk-items { display: flex; flex-direction: column; gap: 16px; }
  .rc-risk-item { display: flex; gap: 16px; padding: 18px 20px; background: #fff; border-radius: 14px; border: 1px solid #fee2e2; }
  .rc-risk-icon-wrap { width: 40px; height: 40px; border-radius: 10px; background: #fee2e2; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
  .rc-risk-title { font-size: 0.95rem; font-weight: 700; color: #991b1b; margin-bottom: 4px; }
  .rc-risk-desc { font-size: 0.85rem; color: #64748b; line-height: 1.6; }
  .rc-service-list { display: flex; flex-direction: column; gap: 20px; }
  .rc-service-item { display: flex; gap: 16px; }
  .rc-service-icon-wrap { width: 42px; height: 42px; border-radius: 12px; background: #fffbeb; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; margin-top: 2px; }
  .rc-service-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 5px; }
  .rc-service-desc { font-size: 0.88rem; color: #64748b; line-height: 1.65; }

  /* ── Process ── */
  .rc-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .rc-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .rc-process-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .rc-process-grid { grid-template-columns: 1fr; } }
  .rc-process-grid::before { content: ''; position: absolute; top: 27px; left: 12.5%; right: 12.5%; height: 2px; background: linear-gradient(90deg, #d97706, #f59e0b); z-index: 0; }
  @media (max-width: 900px) { .rc-process-grid::before { display: none; } }
  .rc-process-step { text-align: center; position: relative; z-index: 1; }
  .rc-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .rc-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .rc-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .rc-cta { background: linear-gradient(135deg, #0d1b3e 0%, #78350f 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .rc-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(245,158,11,0.08); filter: blur(60px); pointer-events: none; }
  .rc-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .rc-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .rc-cta-tag { display: inline-block; background: rgba(245,158,11,0.18); border: 1px solid rgba(245,158,11,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #fcd34d; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .rc-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .rc-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .rc-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .rc-cta-btn-primary { padding: 16px 32px; background: #f59e0b; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .rc-cta-btn-primary:hover { background: #d97706; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(245,158,11,0.4); }
  .rc-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .rc-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .rc-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .rc-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .rc-cta-check { width: 18px; height: 18px; background: rgba(245,158,11,0.22); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #fcd34d; flex-shrink: 0; }
`;

const complianceItems = [
  { icon: "🔒", label: "OSHA Safety Standards", sub: "Workplace safety", badge: "Passing", badgeClass: "rc-badge-pass" },
  { icon: "♿", label: "ADA Compliance", sub: "Accessibility", badge: "Action Needed", badgeClass: "rc-badge-action" },
  { icon: "🌐", label: "GDPR / Data Privacy", sub: "Data handling", badge: "At Risk", badgeClass: "rc-badge-risk" },
  { icon: "📋", label: "State Business License", sub: "Annual renewal", badge: "Passing", badgeClass: "rc-badge-pass" },
];

const areas = [
  { icon: "🏗️", title: "OSHA & Workplace Safety", desc: "Ensure your workplace meets federal and state safety standards with our compliance audits and policy drafting.", tags: ["OSHA 300 Log", "Safety Plans", "Training Docs"] },
  { icon: "♿", title: "ADA & Accessibility", desc: "Protect your business from ADA lawsuits with physical and digital accessibility compliance reviews.", tags: ["Website ADA", "Physical Access", "Policy Review"] },
  { icon: "🌐", title: "Data Privacy (GDPR / CCPA)", desc: "Navigate data collection, storage, and privacy policies to comply with GDPR, CCPA, and state data laws.", tags: ["Privacy Policy", "Data Mapping", "Consent Forms"] },
  { icon: "📋", title: "Business Licensing", desc: "Identify, obtain, and renew every federal, state, and local license your business is required to hold.", tags: ["License Audit", "Renewals", "All 50 States"] },
  { icon: "💼", title: "Industry-Specific Regulations", desc: "From healthcare (HIPAA) to finance (SOX) to food service, we cover the rules governing your specific industry.", tags: ["HIPAA", "SOX", "Food & Bev"] },
  { icon: "🔄", title: "Ongoing Compliance Monitoring", desc: "Laws change. Our monitoring service tracks regulatory updates and alerts you before deadlines arrive.", tags: ["Monthly Reports", "Alerts", "Annual Audit"] },
];

const risks = [
  { icon: "💸", title: "Fines Up to $150,000+", desc: "Regulatory violations carry steep penalties that can cripple small business cash flow overnight." },
  { icon: "⚠️", title: "License Revocation", desc: "Operating without proper licenses can result in forced closure and permanent reputation damage." },
  { icon: "⚖️", title: "Costly Lawsuits", desc: "Non-compliance with employment or safety laws is one of the top triggers for expensive litigation." },
];

const services = [
  { icon: "🔍", title: "Compliance Gap Analysis", desc: "We audit your current operations against applicable regulations to identify every exposure — before regulators do." },
  { icon: "📝", title: "Policy Drafting & Updates", desc: "We draft and update all internal compliance policies, procedures, and employee-facing documentation." },
  { icon: "🔔", title: "Regulatory Monitoring & Alerts", desc: "Receive real-time alerts when laws change in your industry or state so you're never caught off guard." },
  { icon: "🎓", title: "Compliance Training Support", desc: "We provide materials and guidance to train your team on key compliance topics relevant to your business." },
];

const processSteps = [
  { num: "01", title: "Compliance Audit", desc: "We review your business operations against all applicable regulations to uncover gaps." },
  { num: "02", title: "Risk Prioritization", desc: "We rank your compliance risks by severity and likelihood, creating a clear action plan." },
  { num: "03", title: "Remediation & Policy Build", desc: "We draft policies, file registrations, and implement fixes to close every compliance gap." },
  { num: "04", title: "Ongoing Monitoring", desc: "Continuous monitoring, alerts, and annual reviews keep you compliant as regulations evolve." },
];

const LegalRegulatoryCompliance = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="rc-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="rc-hero">
        <div className="rc-hero-blob1" />
        <div className="rc-hero-blob2" />
        <div className="rc-hero-inner">
          <div>
            <button className="rc-back-btn" onClick={() => navigateTo("")}>← Back to Legal Services</button>
            <div className="rc-badge">
              <span className="rc-badge-dot" />
              Regulatory Compliance Services
            </div>
            <h1>
              Stay Compliant,{" "}
              <span className="rc-gradient-text">Stay Protected</span>
            </h1>
            <p className="rc-hero-sub">
              Regulations change constantly. One missed requirement can mean
              fines, lawsuits, or license revocation. Our compliance team monitors
              every rule that applies to your business — so you never have to.
            </p>
            <div className="rc-btn-group">
              <button className="rc-btn-primary">Get a Compliance Audit →</button>
              <button className="rc-btn-secondary">View Coverage Areas</button>
            </div>
            <div className="rc-trust-items">
              {["Federal, state & local", "OSHA · ADA · GDPR · CCPA", "Ongoing monitoring", "Industry-specific coverage"].map((t, i) => (
                <div key={i} className="rc-trust-item">
                  <span className="rc-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="rc-hero-card">
            <div className="rc-card-header">
              <div>
                <div className="rc-card-title-label">Your Business</div>
                <div className="rc-card-title-value">Compliance Dashboard</div>
              </div>
              <span className="rc-card-status-badge">⚠ 2 Items Need Attention</span>
            </div>
            {complianceItems.map((item, i) => (
              <div key={i} className="rc-compliance-item">
                <div className="rc-comp-left">
                  <span className="rc-comp-icon">{item.icon}</span>
                  <div>
                    <div className="rc-comp-label">{item.label}</div>
                    <div className="rc-comp-sub">{item.sub}</div>
                  </div>
                </div>
                <span className={`rc-comp-badge ${item.badgeClass}`}>{item.badge}</span>
              </div>
            ))}
            <div className="rc-score-bar">
              <div className="rc-score-top">
                <div className="rc-score-label">Overall Compliance Score</div>
                <div className="rc-score-value">78 / 100</div>
              </div>
              <div className="rc-score-bar-track">
                <div className="rc-score-bar-fill" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="rc-stats">
        <div className="rc-stats-grid">
          {[
            { num: "$150K+", label: "Avg. Fine We Help Prevent" },
            { num: "1,800+", label: "Businesses Audited" },
            { num: "40+", label: "Regulations Monitored" },
            { num: "100%", label: "Deadline Compliance Rate" },
          ].map((s, i) => (
            <div key={i} className="rc-stat-item">
              <div className="rc-stat-num">{s.num}</div>
              <div className="rc-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Compliance Areas ── */}
      <section className="rc-section rc-areas-bg">
        <div className="rc-container">
          <div className="rc-section-header">
            <div className="rc-kicker">Coverage Areas</div>
            <h2>Every Regulation That Affects Your Business</h2>
            <p>
              From federal safety standards to state data privacy laws, we monitor
              and manage compliance across every dimension of your operation.
            </p>
          </div>
          <div className="rc-areas-grid">
            {areas.map((area, i) => (
              <div key={i} className="rc-area-card">
                <div className="rc-area-icon">{area.icon}</div>
                <div className="rc-area-title">{area.title}</div>
                <div className="rc-area-desc">{area.desc}</div>
                <div className="rc-area-tags">
                  {area.tags.map((tag, j) => (
                    <span key={j} className="rc-area-tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Risk + Services ── */}
      <section className="rc-section">
        <div className="rc-container">
          <div className="rc-risk-grid">
            <div className="rc-risk-left">
              <div className="rc-kicker">The Cost of Non-Compliance</div>
              <h2>Ignoring Compliance Is a Risk You Can't Afford</h2>
              <p>
                Small businesses are not exempt from regulatory scrutiny. In fact,
                they're often targeted first because of limited legal resources.
                Here's what's at stake.
              </p>
              <div className="rc-risk-items">
                {risks.map((r, i) => (
                  <div key={i} className="rc-risk-item">
                    <div className="rc-risk-icon-wrap">{r.icon}</div>
                    <div>
                      <div className="rc-risk-title">{r.title}</div>
                      <div className="rc-risk-desc">{r.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="rc-kicker">How We Help</div>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 800, color: '#0d1b3e', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '36px' }}>
                Our Compliance Services
              </h2>
              <div className="rc-service-list">
                {services.map((s, i) => (
                  <div key={i} className="rc-service-item">
                    <div className="rc-service-icon-wrap">{s.icon}</div>
                    <div>
                      <div className="rc-service-title">{s.title}</div>
                      <div className="rc-service-desc">{s.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="rc-section rc-process-bg">
        <div className="rc-container">
          <div className="rc-section-header">
            <div className="rc-kicker">How It Works</div>
            <h2>From Audit to Ongoing Protection</h2>
            <p>Our 4-step compliance program gets you covered quickly and keeps you protected long-term.</p>
          </div>
          <div className="rc-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="rc-process-step">
                <div className="rc-process-num">{step.num}</div>
                <div className="rc-process-title">{step.title}</div>
                <div className="rc-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="rc-cta">
        <div className="rc-cta-blob1" />
        <div className="rc-cta-blob2" />
        <div className="rc-cta-inner">
          <div className="rc-cta-tag">Free Compliance Audit</div>
          <h2>Know Where You Stand Before Regulators Do</h2>
          <p>
            Get a free compliance gap analysis and discover exactly where your
            business is exposed. Our team will map every risk and build a clear
            remediation plan — at no cost.
          </p>
          <div className="rc-cta-btn-group">
            <button className="rc-cta-btn-primary">Get Free Compliance Audit</button>
            <button className="rc-cta-btn-secondary">Talk to a Specialist</button>
          </div>
          <div className="rc-cta-reassurances">
            {["No obligation audit", "All industries covered", "Results in 48 hours", "Ongoing monitoring available"].map((r, i) => (
              <div key={i} className="rc-cta-reassurance">
                <span className="rc-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalRegulatoryCompliance;
